import { Button } from '@components/core-ui/form-elements/buttons/Button/';
import { OutlinedButton } from '@components/core-ui/form-elements/buttons/Button/variations/OutlinedButton';
import { Select } from '@components/core-ui/form-elements/Select';
import { useAPI } from '@providers/useAPI';
import { useAuthContext } from '@providers/AuthProvider';
import { JobResponseDto, JobsService, OrganizationsService } from 'app/API';
import { useEffect, useState } from 'react';

import { ModalWrapper } from '@modals/core-ui/ModalWrapper';
import { ModalTitle } from '@modals/core-ui/ModalTitle';
import { Content } from './EditJobCaseModal/styles/Content';

type RepositoryItem = {
  label: string;
  value: string;
};

type TProps = {
  job: JobResponseDto;
  onCancel: () => void;
  onSuccess: () => void;
};

export const EditJobCaseModal = ({ job, onCancel, onSuccess }: TProps) => {
  const { call } = useAPI();
  const { organization } = useAuthContext();
  const [repositoryList, setRepositoryList] = useState<RepositoryItem[]>([]);
  const [repositoryId, setRepositoryId] = useState<string>(job?.repositoryId || job?.repository?.id || '');

  const handleSubmit = async () => {
    await call(JobsService.updateCase({ jobId: job.id, wsid: job.workspaceId ?? '', requestBody: { repositoryId } }));
    onSuccess();
  };

  useEffect(() => {
    if (!organization) {
      return;
    }
    (async () => {
      const result = await call(OrganizationsService.getOrgReposList({ oid: organization.id }));
      setRepositoryList(
        [
          {
            value: '',
            label: 'No case selected',
          },
        ].concat(
          result.map((item) => ({
            value: item.id,
            label: item.name,
          })),
        ),
      );
    })();
  }, [organization, job?.repositoryId]);

  return (
    <ModalWrapper width="487px">
      <ModalTitle>Edit Job Case</ModalTitle>
      <Content>
        <Select
          name="repositoryId"
          label="Case"
          value={repositoryId}
          onChange={(_, value) => setRepositoryId(value)}
          options={repositoryList}
          required={false}
        />

        <div className="buttonGroup">
          <OutlinedButton onClick={onCancel}>Cancel</OutlinedButton>
          <Button onClick={handleSubmit}>Save</Button>
        </div>
      </Content>
    </ModalWrapper>
  );
};
